<template>
  <v-autocomplete
    v-model="item"
    :loading="loading"
    :items="items"
    :search-input.sync="search"
    hide-no-data
    hide-details
    return-object
    :label="label"
    :filter="filter"
    class="mx-3"
    flat
    label="Hledat"
    solo-inverted
    hide-selected
  >
    <template
      slot="selection"
      slot-scope="{ item, selected }"
    >
      <span v-if="item.typ=='klient'" class="body-1 v-select__selection-text">
        Klient {{item.nazev}}
      </span>
      <span v-else-if="item.typ=='zajemce'" class="body-1 v-select__selection-text">
        Zájemce {{item.nazev}}
      </span>
    </template>
    <template
      slot="item"
      slot-scope="{ item, tile }"
    >
    <v-list-tile-content>
      <v-list-tile-title>
        <div v-if="item.typ=='klient'" class="body-1">
          Klient <strong>{{item.nazev}}</strong>
        </div>
        <span v-else-if="item.typ=='zajemce'" class="body-1">
          Zájemce <strong>{{item.nazev}}</strong>
        </span>
      </v-list-tile-title>
    </v-list-tile-content>
    </template>
  </v-autocomplete>
</template>
<script>
export default {
  data () {
    return {
      loading: false,
      items: [],
      search: "",
      counter: 0,
      timeout: null,
      item: null
    }
  },
  props: {
    label: String
  },
  watch: {
    search (val) {
      val && val !== this.item && val.length > 0 && this.queryClients(val)
    },
    item (val) {
      if (val.typ === 'klient') {
        this.$router.push({ path: '/klienti/'+val.id })
      }
      else if (val.typ === 'zajemce') {
        this.$router.push({ path: '/zajemci/'+val.id })
      }
      this.search = "";
      this.item = null;
      this.items = [];
    }
  },
  mounted: function() {
    console.log(this.value);
  },
  methods: {
    filter: function(e) {
      return true;
    },
    queryClients: function(v) {
      this.counter++;
      if (this.timeout != null)
        clearTimeout(this.timeout);
      this.timeout = setTimeout(function() {
        this.loading = true
        window.api.post("search/bar", {
          s: v,
          echo: this.counter
        }).then(function($r) {
          if ($r.echo != this.counter) return;
          this.items = $r.data;
          this.loading = false;
        }.bind(this)).catch(function(err) {
          console.log(err);
        }.bind(this));
      }.bind(this), 200)
    }
  },
  components: {

  }
}
</script>
<style scoped>
.v-select__selection-text {
  max-width: 300px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/SearchBar.vue